import styled from "styled-components/macro";
import { useTheme } from "@mui/material/styles";
import { useSelector, useDispatch } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { CssBaseline, useMediaQuery } from "@mui/material";
import React, { useState, useEffect, Fragment } from "react";

import pages from "../constants/pages";
import GlobalStyle from "../components/GlobalStyle";
import Navbar from "./dashboard layout components/Navbar";
import Footer from "./dashboard layout components/Footer";
import { signInMember } from "../redux/slices/memberSlice";
import Sidebar from "./dashboard layout components/Sidebar";
import MainContent from "./dashboard layout components/MainContent";
import WebsiteLoader from "./dashboard layout components/WebsiteLoader";

const ContentWrapper = styled.div`
  display: flex;
  height: calc(100% - 64px);
`;

const MainContentWrapper = styled.div`
  flex: 1;
  margin: 4px;
  overflow: auto;
  display: flex;
  flex-direction: column;
`;

export default function DashboardLayout() {
  const theme = useTheme();

  const dispatch = useDispatch();

  const { pathname } = useLocation();

  const isLaptop = useMediaQuery(theme.breakpoints.up("sm"), { noSsr: true });

  const [sidebarState, setSidebarState] = useState({
    static: false,
    open: false,
  });

  const localStorageToken = localStorage.getItem("authToken");

  const sessionStorageToken = sessionStorage.getItem("authToken");

  const { authToken } = useSelector((state) => state.memberDetails);

  useEffect(() => {
    if (!authToken && (localStorageToken || sessionStorageToken)) {
      pathname.includes("/chats/") &&
        pathname.replace(`/chats/`, "").split("*")[0] !== "all" &&
        localStorage.setItem(
          "activeBot",
          pathname.replace(`/chats/`, "").split("*")[0]
        );

      dispatch(
        signInMember({
          authToken: localStorageToken || sessionStorageToken,
          rememberMe: !!localStorageToken,
        })
      );
    }
  }, [authToken, dispatch, localStorageToken, sessionStorageToken]);

  if (!(authToken || localStorageToken || sessionStorageToken)) {
    return (
      <Navigate
        to={`${pages.signIn.route}?redirect=back`}
        state={{ from: pathname }}
      />
    );
  }

  if (!authToken && (localStorageToken || sessionStorageToken)) {
    return (
      <Fragment>
        <CssBaseline />
        <GlobalStyle />

        <WebsiteLoader />
      </Fragment>
    );
  }

  return (
    <Fragment>
      <CssBaseline />
      <GlobalStyle />

      <Navbar sidebarState={sidebarState} toggleSideBar={toggleSidebarState} />

      <ContentWrapper>
        <Sidebar
          sidebarState={sidebarState}
          onMouseEnter={mouseEnterSidebar}
          onMouseLeave={mouseLeaveSidebar}
        />

        <MainContentWrapper>
          <MainContent />

          <Footer />
        </MainContentWrapper>
      </ContentWrapper>
    </Fragment>
  );

  function toggleSidebarState() {
    setSidebarState((prevValue) => ({
      static: !prevValue.static,
      open: !prevValue.open,
    }));
  }

  function mouseEnterSidebar() {
    if (isLaptop && !sidebarState.static) {
      setSidebarState((prevValue) => ({
        ...prevValue,
        open: true,
      }));
    }
  }

  function mouseLeaveSidebar() {
    if (isLaptop && !sidebarState.static) {
      setSidebarState((prevValue) => ({
        ...prevValue,
        open: false,
      }));
    }
  }
}
